import { useSelector, useDispatch } from "react-redux";
import { useSortable } from "@dnd-kit/sortable";
import classNames from "classnames";
import { CSS } from "@dnd-kit/utilities";
import { useSortableListContainer } from "@uiview/views/AISaas/SortableList/container";
import { SortableToolbar } from "@uiview/views/AISaas/SortableList/components/SortableToolbar";
import css from "./index.module.scss";
import { useMemo, useRef } from "react";
import { SortableListUtil } from "@uiview/views/AISaas/SortableList/util";
import func, { matchMobile } from "@uikit/func";
import { fotActions } from "@store/fot";
import { useAISaasPreviewItem } from "@uiview/views/AISaas/hooks/useAISaasPreviewItem";
import { typeMap } from "@uiview/views/PreviewV2ToolBar/PreviewV2ToolBarUtil";
import { logEvent } from "@uikit/service/amplitude";
import { getIt } from "@uikit/getIt";
import { ChatOnboardingStore } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboarding";
import { TalkBuilder } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboardingType";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { useStore as useImagicaStore } from "imagica-uikit/dist/hooks/useStore";
import { previewStore } from "@uiview/store/PreviewStore";
import { CreatorSaasAppStore } from "@uiview/views/ProjectCanvas/store/CreatorSaasAppStore";
import { NodeTitleUtil } from "@uiview/views/Nodes/NodeTitleUtil";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { useNodesTitle } from "@custom-hooks/HomeUsePluginRoot/useNodesTitle";

const creatorSaasAppStore = getIt(CreatorSaasAppStore);
export function SortableItem<T>(props: SortableList.ItemProps<T>): JSX.Element {
  const dispatch = useDispatch();
  // const longPressTimer = useRef<any>(null);
  const isMobile = matchMobile();
  const homeStore = getIt(HomeStore);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const featureTags = homeStore.state.featureTags;
  const chatOnboardingStore = getIt(ChatOnboardingStore);
  const chatOnboardingState = useImagicaStore(chatOnboardingStore).value;
  const { id: talkBuilderId } = chatOnboardingState.talkBuilder;

  const editorImageScrollDireaction = useSelector((state: any) => state.fot.editorImageScrollDireaction);
  const setImageScrollDireaction = (val: any): void => {
    dispatch(fotActions.setImageScrollDireaction(val));
  };

  const { onPreviewItemMouseEnter } = useAISaasPreviewItem();

  const previewState = useImagicaStore(previewStore).value;

  const { index, value, children, renderItemChildren, type } = props;
  const { onSwitch, disabled } = useSortableListContainer();
  const { id, data } = value;
  const nodeData: any = { ...data };
  const nodeId = type === "output" ? nodeData?.groupDnd?.[0]?.results?.[0]?.nodeId : nodeData.id;
  const { inputTitle } = useNodesTitle(nodeId);

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    disabled: !id,
    id: id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const sortableProps = { id, attributes, listeners, setNodeRef, style, type };

  const outputV2Item = useMemo(() => {
    const outputV2 = creatorSaasAppStore.state.saasUIData.outputV2;

    return outputV2?.find(x => x.id === nodeData?.groupDnd?.[0]?.id);
  }, [creatorSaasAppStore.state.saasUIData]);

  const renderChild = (): any => {
    if (renderItemChildren) {
      return renderItemChildren({
        value,
        sortableProps,
        index,
      });
    }

    return children;
  };

  // console.log(creatorSaasAppStore.state.saasUIData.outputV2, "creatorSaasAppStore.state.saasUIData.outputV2");
  // console.log(nodeData, nodeData?.groupDnd?.[0]?.id, "nodeData?.groupDnd?.[0]?.id");

  const SortableItemRef = useRef<HTMLDivElement>(null);
  // const rect = SortableItemRef.current?.getBoundingClientRect();

  const sortableItemId = SortableListUtil.generateDomIdAttr(id);

  const confirmDeleteBox = (id: any): void => {
    let arr: any[] = [];
    // bsf-4912 replace thoughts
    const tempThoughts = creatorSaasAppStore.state.saasUIData.output;
    //  判断groupDnd有多个或者第一个的groupId如果存在 则表示是group
    if (nodeData?.groupDnd?.length > 1 || nodeData?.groupDnd?.[0]?.groupId) {
      // 删除group
      if (editorImageScrollDireaction !== "horizontalScroll") {
        arr = tempThoughts.filter(x => x.groupId !== id);
      } else {
        const results = tempThoughts[0].results;
        const filterResults = results.filter((x: any) => x.parentNode !== id);
        if (func.isEmpty(filterResults)) {
          setImageScrollDireaction("verticallyScroll");
        } else {
          arr = [
            {
              ...tempThoughts[0],
              results: filterResults,
            },
          ];
        }
      }
    } else {
      // 删除单个
      tempThoughts.forEach(x => {
        const noDelArr = x.results.filter((r: any) => r.previewId !== id);
        if (!func.isEmpty(noDelArr)) {
          arr.push({
            ...x,
            results: noDelArr,
          });
        }
      });
    }
    // bsf-4912 use setSassUIData
    creatorSaasAppStore.setSaasUIData(prev => ({ ...prev, output: arr }));
  };

  const getType = useMemo(() => {
    let type = "";
    if (nodeData?.groupDnd?.length) {
      type = nodeData.groupDnd[0].results?.[0]?.type;
    } else {
      type = nodeData?.data?.displayType;
    }
    return typeMap[type] || "default";
  }, [nodeData]);

  const getNodeIdAndLabel = useMemo(() => {
    const label = outputV2Item?.data?.blank?.title;
    const id = nodeData?.groupDnd?.[0]?.results?.[0]?.nodeId;
    /**
     * judge if it is group node
     */
    // output group
    if (nodeData?.groupDnd?.length > 1 || nodeData?.groupDnd?.[0]?.groupId) {
      return { id: nodeData?.id, label: NodeTitleUtil.outputTitle(label) };
    }
    // input
    else if (nodeData?.data) {
      return { id: nodeData.id, label: NodeTitleUtil.getNodeTitle(nodeData) };
    }
    // output
    else {
      return { id, label: inputTitle || label };
    }
  }, [nodeData, outputV2Item, inputTitle]);

  //  重新挂载后触发一次talkbuilder的更新
  /* useEffect(() => {
    const content = chatOnboardingState.talkBuilder.content;
    if (content && document.getElementById(content)) {
      chatOnboardingStore.setTalkBuilder({
        ...chatOnboardingStore.state.talkBuilder,
      });
    }
    // eslint-disable-next-line
  }, [chatOnboardingState.talkBuilder.content]); */

  /* useEffect(() => {
    if (chatOnboardingState.isDisableChat) {
      chatOnboardingStore.setTalkBuilder(new TalkBuilder());
    }
    // eslint-disable-next-line
  }, [chatOnboardingState.isDisableChat]); */

  /* const touchStart = (): void => {
    longPressTimer.current = setTimeout(() => {
      openToolBar();
    }, 500);
  }; */

  /*  const touchEnd = (): void => {
    longPressTimer.current && clearTimeout(longPressTimer.current);
  }; */

  const openOutputToolBar = (): void => {
    // if (!(isMobile && featureTags.disableMobilePage)) {
    openToolBar();
    // }
  };

  const openToolBar = (): void => {
    if (type === "output") {
      onPreviewItemMouseEnter({
        type: getType,
        talkBuilderEdit: () => {
          chatOnboardingStore.setChatOnboardingState({
            talkBuilder: {
              ...new TalkBuilder(),
              id: id as string,
              content: getNodeIdAndLabel.label,
            },
          });
        },
        remove: () => {
          const result = creatorSaasAppStore.state.saasUIData.output.find(item => {
            return item.results[0].previewId === id;
          });
          const tempNode = creatorNodesStore.getNodes().find(node => {
            return node.id === result?.results[0].nodeId;
          });
          logEvent("publish_preview_remove_content", { node: tempNode });

          confirmDeleteBox(id);
        },
        container: SortableItemRef.current,
        id,
      });
    }
  };

  // const validId = id.toString().replaceAll("*", "");
  const showTalkBuilderBorder = talkBuilderId === id;

  return (
    <div
      id={getNodeIdAndLabel.label}
      onClick={openOutputToolBar}
      // onTouchStart={touchStart}
      // onTouchEnd={touchEnd}
      className={classNames(
        css["sortable-item"],
        { [css["sortable-item-mobile"]]: isMobile && featureTags.disableMobilePage },
        { [css.talkBuilderBorder]: showTalkBuilderBorder }
        // { [css.topIndex]: talkBuilderId === id }
      )}
      data-testid="SortableItem"
      ref={SortableItemRef}
      {...sortableItemId}
    >
      {type === "output" && !featureTags.disableMultiRoundChatOnboarding && (
        <div className={css.outputlabel}>{getNodeIdAndLabel.label}</div>
      )}
      <SortableToolbar
        hideHandle={disabled || previewState.isClickAddToContent}
        sortableProps={sortableProps}
        onSwitch={onSwitch}
      >
        {/* <div style={{ wordBreak: "break-word" }}>{JSON.stringify(rect)}</div> */}
        {renderChild()}
      </SortableToolbar>
    </div>
  );
}
